import Svg, { Path } from 'react-native-svg'

export const RupeeIcon = ({ height = 16, width = 16, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M12 5.333h-1.393a4 4 0 0 0-.967-2H12A.667.667 0 1 0 12 2H4a.667.667 0 0 0 0 1.333h2.667a2.667 2.667 0 0 1 2.573 2H4a.667.667 0 0 0 0 1.334h5.24a2.667 2.667 0 0 1-2.573 2H4.613a.433.433 0 0 0-.133 0l-.12.04-.1.073a.667.667 0 0 0-.1.093l-.04.04v.06a.607.607 0 0 0-.12.294v.066a.16.16 0 0 0 0 .054.433.433 0 0 0 0 .133c.01.04.024.081.04.12l.073.1.094.1.04.04 6.666 4.667c.123.086.27.128.42.12a.667.667 0 0 0 .38-1.214L6.773 10a4 4 0 0 0 3.834-3.333H12a.667.667 0 1 0 0-1.334Z"
      />
    </Svg>
  )
}
